// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uuoxO7tC{margin:0;white-space:pre-wrap}`, "",{"version":3,"sources":["webpack://./src/page-components/shared/confirmation-modal.module.scss"],"names":[],"mappings":"AAAA,UACE,QAAA,CACA,oBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textContent": `uuoxO7tC`
};
export default ___CSS_LOADER_EXPORT___;
